import { render } from "./LayoutNone.vue?vue&type=template&id=157cd0dc"
import script from "./LayoutNone.vue?vue&type=script&lang=js"
export * from "./LayoutNone.vue?vue&type=script&lang=js"

import exportComponent from "D:\\01. Workspace\\orot_kiosk\\src\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__